
/*
Script for adding Structured data to document head tag
Author: Čeněk Hybler
Date: December 2020

Components maintained: FAQ Accordion
*/

(function() {
	'use strict';
	var $ = avm.require('jquery'),
		$faq_holder = $('[data-structured-type="faq"]'),

		/* Function for JSON stringify and Script injection */
		jsonInjection = function(contextType, content){
			var el = document.createElement('script');
			var jsonIntro = {
					"@context": "http://schema.org",
					"@type": contextType
				},
				json = Object.assign(jsonIntro, content);

			el.type = 'application/ld+json';
			el.text = JSON.stringify(json);

			//console.log(el);
			document.querySelector('head').appendChild(el);
		};


	$(document).ready(function(){
		//FAQ
		if ($faq_holder) {
			$faq_holder.each(function(){
				var contextType = 'FAQPage',
					$items = $(this).find('.js-question'),
					content = {},
					contentJson = [];


				$items.each(function() {
					contentJson.push({
						"@type": "Question",
						"name": $(this).find('h5').text().replaceAll('\t','').replaceAll('\n',''),
						"acceptedAnswer": {
							"@type": "Answer",
							"text": $(this).find('p').html().replaceAll('\t','').replaceAll('\n','')
						}
					})
				});
				content['mainEntity'] = contentJson;

				jsonInjection(contextType, content);
			});
		}
	});
})();
